import type { UseMutationResult } from '@tanstack/react-query'

export const mutationFactoryHandler = <DataType extends { taskId: string }>(
  mutation: UseMutationResult<void, unknown, DataType, unknown>,
  taskId?: string | null,
  args?: Omit<DataType, 'taskId'>
): void => {
  if (!taskId) return

  const data = { taskId, ...args }

  mutation.mutate(data as DataType)
}
